import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciLoaderComponent } from './luci-loader.component';



@NgModule({
  declarations: [LuciLoaderComponent],
  exports: [LuciLoaderComponent],
  imports: [
    CommonModule
  ]
})
export class LuciLoaderModule { }
